import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivationJourneyService } from '../../onboarding-checklist/activation-journey.service';
import { ExampleWorkdayService } from '../example-workday.service';
import { EXAMPLE_PREVIEW_COPY } from './example-preview-copy';
import { WhatYouControlComponent } from './what-you-control.component';

@Component({
  selector: 'app-example-preview-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, WhatYouControlComponent],
  templateUrl: './example-preview-card.component.html',
  styleUrl: './example-preview-card.component.css',
})
export class ExamplePreviewCardComponent implements OnInit {
  readonly copy = EXAMPLE_PREVIEW_COPY;

  /** 'hours' | 'apps' — which example body to show when not projecting. */
  @Input() variant: 'hours' | 'apps' = 'hours';
  /** When true, use own-workday “Your data” headline. */
  @Input() ownWorkdayReady = false;
  @Input() showControlCard = true;
  @Input() showTryCta = true;
  @Output() tryOneEmployee = new EventEmitter<void>();

  constructor(
    private exampleWorkday: ExampleWorkdayService,
    private activationJourney: ActivationJourneyService
  ) {}

  ngOnInit(): void {
    this.activationJourney.trackEvent('example_preview_shown', {
      data_source: 'scoped_example',
      variant: this.variant,
    });
    if (this.showControlCard) {
      this.activationJourney.trackEvent('control_awareness_shown', {
        source: 'example_preview_card',
      });
    }
  }

  get workday() {
    return this.exampleWorkday.workday;
  }

  get yourDataBody(): string {
    return this.ownWorkdayReady ? this.copy.yourDataOwnDay : this.copy.yourDataThin;
  }

  get exampleLead(): string {
    return this.variant === 'apps' ? this.copy.exampleLeadApps : this.copy.exampleLeadHours;
  }

  onTryOneEmployee(): void {
    this.tryOneEmployee.emit();
    this.exampleWorkday.goTryOneEmployeeFromExplore();
  }
}
